<template>
  <div class="lower mt-4 mb-0 bg-white w-full p-4">
    <h2 class="pl-4 font-semibold mb-4 mt-4" v-if="!isEmpty">Sales History</h2>
    <i class="el-icon-refresh float-right text-xl text-red-500 cursor-pointer" v-if="isFailing"></i>
    <table class="w-full" v-if="!isEmpty && !loading && !isFailing">
      <tr class="table-header border-b border-b-8 border-gray-200 sticky">
        <th class="font-light text-left font-medium">Order No</th>
        <th class="font-light text-left font-medium">Customer</th>
        <th class="font-light text-left font-medium">Status</th>
        <th class="font-light text-left font-medium">Amount</th>
        <th class="font-light text-left font-medium">Ordered</th>
      </tr>
      <tbody>
        <TableData v-for="sale in sales" :details="sale"/>
      </tbody>
    </table>
    <SalesHistoryLoader v-if="loading" />
    <EmptyData v-if="!loading && isEmpty && !isFailing" :options="emptyDataOptions" class="mt-32" />
    <EmptyData v-if="!loading && isFailing" :options="errorOptions" class="mt-32" />
  </div>
</template>

<script>
import SalesHistoryLoader from './loaders/sales_history_loader.vue';
import TableData from './includes/sales-history/table_data.vue';
import EmptyData from '../../Common/components/empty_data.vue';

export default {
  name: 'sales_history',
  data() {
    return {
      loading: false,
    };
  },
  components: {
    SalesHistoryLoader,
    TableData,
    EmptyData,
  },
  computed: {
    sales() {
      return this.$store.state.Dashboard.sales;
    },
    emptyDataOptions() {
      return {
        image: 'no-sales.png',
        text: 'You currently have no new sales for the month.',
        classes: 'w-3/4 italic text-sm',
      };
    },
    errorOptions() {
      return {
        image: 'unavailable.png',
        text: 'We are not able to fetch your data now, please click the refresh icon to try again.',
        classes: 'w-3/4 italic text-sm text-red-500',
      };
    },
  },
  methods: {
    async fetchSalesHistory() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch('Dashboard/fetchSalesHistory');
        this.isEmpty = response.salesHistory.length < 1;
      } catch (e) {
        this.isFailing = true;
      }

      this.loading = false;
    },
  },
  async mounted() {
    await this.fetchSalesHistory();
  },
};


</script>

<style scoped lang="scss">
.lower {
  height: auto;
  overflow-x: hidden;
  overflow-y: scroll;
}
.table-header {
  th {
    padding: 1rem;
  }
}
</style>
